// T2T-05-C6 — Vendor portal chat API. Token-authenticated (no JWT).
//
// Token rides as ?vendor_token=… (read endpoints / EventSource) or in the
// Authorization: VendorToken header (writes). FetchApiServices is JWT-only,
// so this module talks directly via fetch.

import { ServerURL } from "../FetchApiServices";

const BASE = `${(ServerURL || "").replace(/\/$/, "")}/t2t/vendor-chat`;

function _buildHeaders(token) {
  return {
    "Content-Type":  "application/json;charset=utf-8",
    Authorization:   `VendorToken ${token}`,
  };
}

async function _doFetch(method, path, token, body) {
  const url = `${BASE}${path}`;
  const opts = {
    method,
    headers: _buildHeaders(token),
  };
  if (body !== undefined) opts.body = JSON.stringify(body);
  const r = await fetch(url, opts);
  let payload = null;
  try { payload = await r.json(); } catch (_) { /* possibly empty */ }
  if (!r.ok) {
    const msg = payload?.message || `HTTP ${r.status}`;
    return { error: { status: r.status, message: msg }, data: payload };
  }
  return { data: payload, error: null };
}

export const fetchVendorThreadResolve = (token) =>
  _doFetch("GET", "/resolve", token);

export const fetchVendorMessages = (token, params = {}) => {
  const q = new URLSearchParams(
    Object.fromEntries(Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== ""))
  ).toString();
  return _doFetch("GET", `/messages${q ? `?${q}` : ""}`, token);
};

export const sendVendorMessage = (token, body) =>
  _doFetch("POST", "/messages", token, body);

// T2T-05-C7: vendor-side attachment upload (presign + register).
export const presignVendorAttachment = (token, body) =>
  _doFetch("POST", "/attachments/presign", token, body);

export const registerVendorAttachment = (token, body) =>
  _doFetch("POST", "/attachments", token, body);

// Direct PUT to the pre-signed S3 URL — bypasses our token auth entirely.
export async function uploadVendorFileToS3(presignedUrl, file, contentType) {
  const resp = await fetch(presignedUrl, {
    method: "PUT",
    headers: { "Content-Type": contentType },
    body: file,
  });
  if (!resp.ok) {
    const text = await resp.text().catch(() => "");
    throw new Error(`S3 upload failed: ${resp.status} ${text || resp.statusText}`);
  }
  return true;
}

// SSE URL builder — token in query because EventSource cannot send headers.
export function buildVendorStreamUrl(token) {
  return `${BASE}/stream?vendor_token=${encodeURIComponent(token)}`;
}
